import React from 'react';
import { FormattedMessage } from 'react-intl';

import Text from 'app/components/layout/Text.styled';
import Styled from 'app/features/couponCampaign/landing/components/Perks/Perks.styled';

const StreamOnDevices = () => (
  <Styled.Perk data-t="stream-on-device-perk">
    <Styled.PerkIcon viewBox="0 0 40 40" color="--colors-blue-bright">
      <path d="M21.5 33.5H28v3H12v-3h6.5V28H3V5h32v7h2v18H24v-2h-2.5v5.5zM34 15h-7v12h7V15zm-2-7H6v17h18V12h8V8z" />
    </Styled.PerkIcon>
    <Text as={Styled.PerkDescription} size="l">
      <FormattedMessage id="coupon_landing_stream_on_multiple_devices_perk" />
    </Text>
  </Styled.Perk>
);

export default StreamOnDevices;
